import InlineSVG from "inline-svg-react";
import React from "react";

const HomeArrow = (props) => {
  let customIcon = null;
  try {
    customIcon = require("!!raw-loader!../../../public_skin/icons/HomeArrow.svg");
  } catch (err) {
    try {
      customIcon = require("!!raw-loader!../../../public/icons/HomeArrow.svg");
    } catch (err) {
      return (
        <svg viewBox="0 0 15 15" {...props}>
          <path d="M 5 5 10 10 5 15 10 10 Z" />
        </svg>
      );
    }
  }
  if (customIcon !== null) {
    return <InlineSVG icon={customIcon.default} {...props} />;
  }
};
export default HomeArrow;
